// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import React from "react";
import { CameraSelection } from "amazon-chime-sdk-component-library-react";

const CameraDevices = () => {
  return <CameraSelection />;
};

export default CameraDevices;
